import request from '@/utils/request'
import axios from 'axios'

export function createTag(data: Record<string, any>) {
  return request({
    url: '/api/design/tag/create',
    method: 'post',
    data,
  })
}
export function getTagPage(data: Record<string, any>) {
  return request({
    url: '/api/design/tag/pages',
    method: 'get',
    params: data,
  })
}
export function getCategoryPage(data: Record<string, any>) {
  return request({
    url: '/api/design/category/pages',
    method: 'get',
    params: data,
  })
}
export function createCategory(data: Record<string, any>) {
  return request({
    url: '/api/design/category/create',
    method: 'post',
    data,
  })
}
export function getCategorySuffixes(data: Record<string, any>) {
  return request({
    url: '/api/design/resource/suffixes',
    method: 'get',
    params: data,
  })
}

export function folderOperate(data: Record<string, any>) {
  return request({
    url: '/api/design/resource/folder/operate',
    method: 'post',
    data,
  })
}
export function resourceMove(data: Record<string, any>) {
  return request({
    url: '/api/design/resource/move',
    method: 'post',
    data: data,
  })
}
export function resourceCopy(data: Record<string, any>) {
  return request({
    url: '/api/design/resource/copy',
    method: 'post',
    data: data,
  })
}

export function resourceDetail(data: Record<string, any>) {
  return request({
    url: '/api/design/resource/detail',
    method: 'get',
    params: data,
  })
}
export function resourceFav(data: Record<string, any>) {
  return request({
    url: '/api/design/favorite/toggle',
    method: 'post',
    data: data,
  })
}